import { QualityTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity("qaqc_fibre_lab_analysis")
export class QAQCFibreLabAnalysisEntity {

    @PrimaryGeneratedColumn("increment", { name: 'id' })
    id: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column({
        name: "test_date",
        type: "datetime"
    })
    testDate: Date;

    @Column("varchar", {
        nullable: true,
        name: "lot_number",
        length: 255
    })
    lotNumber: string;

    @Column("varchar", {
        nullable: true,
        name: "work_order_no",
        length: 255
    })
    workOrderNo: string;

    @Column("varchar", {
        nullable: true,
        name: "operation",
        length: 100
    })
    operation: string;

    @Column("varchar", {
        nullable: true,
        name: "prev_operation",
        length: 100
    })
    prevOperation: string;

    @Column("varchar", {
        nullable: false,
        name: "product",
        length: 100
    })
    product: Number;
     @Column("decimal", {
        nullable: false,
        precision: 10,
        scale: 3,
        name: "quantity"
    })
    quantity: number;

    @Column("enum", {
        enum : QualityTypeEnum,
        nullable: true,
        name: "quality"
    })
    quality: QualityTypeEnum;

    @Column("varchar", {
        nullable: true,
        name: "test_type",
        length: 50
    })
    testType: string;

    @Column("varchar", {
        nullable: true,
        name: "analysis_type",
        length: 50
    })
    analysisType: string;

    @Column('decimal', {
    name: 'oil_test',
    precision: 10,
    scale: 2,
    nullable: true
})
oilTest: number;

@Column('varchar', {
    name: 'oil_test_remarks',
    length: 150,
    nullable: true
})
oilTestRemarks: string;

@Column('decimal', {
    name: 'sericin_test',
    precision: 10,
    scale: 2,
    nullable: true
})
sericinTest: number;

@Column('varchar', {
    name: 'sericin_test_remarks',
    length: 150,
    nullable: true
})
sericinTestRemarks: string;

@Column('decimal', {
    name: 'acidity_test',
    precision: 10,
    scale: 2,
    nullable: true
})
acidityTest: number;

@Column('varchar', {
    name: 'acidity_test_remarks',
    length: 150,
    nullable: true
})
acidityTestRemarks: string;

@Column('decimal', {
    name: 'pp_content',
    precision: 10,
    scale: 2,
    nullable: true
})
ppContent: number;

@Column('varchar', {
    name: 'pp_content_remarks',
    length: 150,
    nullable: true
})
ppContentRemarks: string;

@Column('decimal', {
    name: 'moisture_content',
    precision: 10,
    scale: 2,
    nullable: true
})
moistureContent: number;

@Column('varchar', {
    name: 'moisture_content_remarks',
    length: 150,
    nullable: true
})
moistureContentRemarks: string;
@Column('boolean',{
        name:'is_qaqc_approved',
        default:false
    })
    isQAQCApproved : boolean
}
